import BackgroundColorClass from "types/enums/BackgroundColorClass";
import styles from "css/footer/Footer.module.css";
import ResponsiveContainer from "components/ResponsiveContainer";
import TextButton from "components/buttons/TextButton";
import TextButtonTheme from "types/enums/TextButtonTheme";
import FontClass from "types/enums/FontClass";
import GlobalClass from "types/enums/GlobalClass";
import ContactUsModal from "components/modal/ContactUsModal";
import { useState } from "react";
import TwitterIcon from "components/icons/TwitterIcon";
import DiscordIcon from "components/icons/DiscordIcon";
import ColorValue from "types/enums/ColorValue";
import Body1 from "components/text/Body1";
import ColorClass from "types/enums/ColorClass";
import ImageWebp from "components/images/ImageWebp";

function Buttons({
  onClickContactUs,
}: {
  onClickContactUs: () => void;
}): JSX.Element {
  return (
    <div className={styles.buttons}>
      <TextButton
        buttonTheme={TextButtonTheme.White}
        fontClass={FontClass.QuestionText}
        href="/generate"
        type="link_internal"
      >
        Generate
      </TextButton>
      <TextButton
        buttonTheme={TextButtonTheme.White}
        fontClass={FontClass.QuestionText}
        href="/shuffle"
        type="link_internal"
      >
        Shuffle
      </TextButton>
      <TextButton
        buttonTheme={TextButtonTheme.White}
        fontClass={FontClass.QuestionText}
        onClick={onClickContactUs}
      >
        Contact us
      </TextButton>
      <TextButton
        buttonTheme={TextButtonTheme.White}
        fontClass={FontClass.QuestionText}
        href="/how-it-works"
        type="link_internal"
      >
        How it works
      </TextButton>
    </div>
  );
}

export default function Footer(): JSX.Element {
  const [isShown, setIsShown] = useState(false);

  return (
    <>
      <ContactUsModal isShown={isShown} onHide={() => setIsShown(false)} />
      <div className={BackgroundColorClass.Purple}>
        <ResponsiveContainer>
          <div className={styles.containerInner}>
            <a className={GlobalClass.HideText} href="/">
              <ImageWebp className={styles.logo} src="/images/logo.svg" />
            </a>
            <Buttons onClickContactUs={() => setIsShown(true)} />
            <div className={styles.icons}>
              <a
                href="https://twitter.com/themycoverse"
                target="_blank"
                rel="noreferrer"
              >
                <TwitterIcon colorValue={ColorValue.White} />
              </a>
              <a
                href="https://discord.gg/hEJhj4GdSa"
                target="_blank"
                rel="noreferrer"
              >
                <DiscordIcon colorValue={ColorValue.White} />
              </a>
            </div>
            <Body1 className={styles.mycoverse} colorClass={ColorClass.White}>
              a{" "}
              <a className={styles.mycoverseLink} href="https://mycoverse.xyz/">
                Mycoverse
              </a>{" "}
              project
            </Body1>
          </div>
        </ResponsiveContainer>
      </div>
    </>
  );
}
